<template>
  <div class="marketing-automation-form-steps-add-type"
       data-icon="mdi-plus">

    <div class="marketing-automation-form-steps-add-type-title">{{$t('message.automation.message.addAction')}}</div>

    <div class="marketing-automation-form-steps-add-type-actions">
      <button class="marketing-automation-form-steps-add-type-actions-item btn btn-secondary btn-round btn-sm mt-3"
              @click="emitType('TIMER')">
        <i class="marketing-automation-form-steps-add-type-actions-item-icon mdi mdi-clock-outline pointer"></i>
          {{$t('message.automation.message.wait')}}
      </button>

      <button class="marketing-automation-form-steps-add-type-actions-item btn btn-secondary btn-round btn-sm mt-3"
              @click="emitType('SEND')">
        <i class="marketing-automation-form-steps-add-type-actions-item-icon mdi mdi-bullhorn-outline pointer"></i>
        {{$t('message.marketingGenerics.message.send')}}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {},

  computed: {},

  data() {
    return {};
  },

  methods: {
    emitType(type) {
      this.$emit("selected", type);
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-form-steps-add-type {
  .marketing-automation-form-steps-add-type-title {
    color: #707070;
    font-weight: 600;
    text-align: center;
    font-size: 14px;
  }

  .marketing-automation-form-steps-add-type-actions {
    display: flex;
    gap: 10px;

    .marketing-automation-form-steps-add-type-actions-item {
      box-shadow: none;
      font-size: 12px;
      display: flex;
      align-items: center;

      .marketing-automation-form-steps-add-type-actions-item-icon {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-right: 5px;
      }
    }
  }
}
</style>
